// Demo monetization components — visible only to admin users
export function PremiumSidebarAd() {
  return (
    <div className="mt-6 rounded-md overflow-hidden border border-[#E19A32]/30 bg-white shadow-sm" data-testid="demo-premium-ad">
      <div className="bg-[#FDF6EE] px-3 py-1.5 flex items-center justify-between">
        <span className="text-[9px] uppercase tracking-[0.18em] text-[#8A9691] font-ui">Sponsorizzato</span>
        <span className="text-[9px] uppercase tracking-[0.18em] text-[#E19A32] font-ui font-medium">Demo</span>
      </div>
      <div className="relative h-44 overflow-hidden bg-gradient-to-br from-[#FAF0EC] to-[#FDF6EE]">
        <div className="absolute inset-0 flex items-center justify-center font-display text-[#C05C45] text-5xl opacity-25">📚</div>
      </div>
      <div className="p-4">
        <p className="font-display text-xl text-[#1A362D] leading-tight">Tutto per il primo zaino</p>
        <p className="mt-1.5 font-ui text-xs text-[#5C6B64] leading-relaxed">
          Astucci, grembiulini, libretti operativi — preparati al primo giorno con la collezione asilo 2026.
        </p>
        <a href="#" onClick={(e) => e.preventDefault()} className="mt-3 inline-block btn-primary text-xs px-3 py-1.5">
          Scopri la collezione →
        </a>
        <p className="mt-3 text-[9px] uppercase tracking-[0.15em] text-[#8A9691] font-ui">Cartolibreria Bimbo • Brand partner</p>
      </div>
    </div>
  );
}

export function AffiliateReadingList() {
  const books = [
    { title: "Come scegliere la scuola", author: "Daniela Lucangeli", price: "€ 12,50", emoji: "📘" },
    { title: "Il bambino è competente", author: "Jesper Juul", price: "€ 14,90", emoji: "📗" },
    { title: "Le emozioni dei bambini", author: "Isabelle Filliozat", price: "€ 16,00", emoji: "📕" },
  ];
  return (
    <div className="mt-8 pt-6 border-t border-dashed border-[#E8E6E1]" data-testid="demo-affiliate-list">
      <div className="flex items-center justify-between gap-2 mb-3">
        <p className="label-eyebrow text-[#5C6B64]">Letture consigliate per scegliere bene</p>
        <span className="text-[9px] uppercase tracking-[0.15em] text-[#8A9691] font-ui">Demo • Affiliate</span>
      </div>
      <div className="space-y-2">
        {books.map((b) => (
          <a key={b.title} href="#" onClick={(e) => e.preventDefault()} className="flex items-center gap-3 p-2.5 rounded-md hover:bg-[#F2EFEB] transition-colors group">
            <div className="w-10 h-10 rounded bg-[#FDF6EE] flex items-center justify-center text-xl flex-shrink-0">{b.emoji}</div>
            <div className="flex-1 min-w-0">
              <p className="font-ui text-sm text-[#1A362D] font-medium group-hover:text-[#C05C45] transition-colors">{b.title}</p>
              <p className="font-ui text-xs text-[#8A9691]">{b.author} • {b.price}</p>
            </div>
            <span className="font-ui text-xs text-[#C05C45] flex-shrink-0">Acquista →</span>
          </a>
        ))}
      </div>
      <p className="mt-2 text-[10px] text-[#8A9691] italic">Acquistando da questi link, una piccola percentuale sostiene Per manina senza costi aggiuntivi per te.</p>
    </div>
  );
}
